import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

type ProtectedRouteProps = {
  adminOnly?: boolean;
};

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ adminOnly = false }) => {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    // Tela de carregamento
    return (
      <div className="flex items-center justify-center min-h-screen bg-cinza-escuro">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-vermelho-claro"></div>
      </div>
    );
  }

  // Se não estiver autenticado, redireciona para o login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Se a rota for apenas para admin e o usuário não for admin
  if (adminOnly && !isAdmin) {
    return <Navigate to="/home" replace />;
  }

  // Renderiza o conteúdo protegido
  return <Outlet />;
};

export default ProtectedRoute; 